/**
 * useUpgradeDialog — imperative opener for the shared Upgrade dialog
 * (docs/plans/TIER_GATING_PLAN.md §B.3/B.5). The dialog itself is mounted
 * once app-wide by `UpgradeDialogProvider` (src/components/Providers.tsx).
 *
 * Components call `openUpgradeDialog(featureKey)`; the global 402 handler in
 * src/lib/api.ts dispatches the same underlying window event directly
 * (it isn't a component, so it can't use this hook) — see
 * FEATURE_NOT_IN_PLAN_EVENT below, shared by both paths.
 */
'use client'

import { useContext } from 'react'

import type { FeatureKey } from '@shared/entitlements'

import { UpgradeDialogContext } from '@/components/entitlements/UpgradeDialogProvider'

/** Window event name the global 402 handler (src/lib/api.ts) dispatches directly
 *  (it runs outside React, so it can't call this hook) — UpgradeDialogProvider
 *  listens for the same event this hook's `openUpgradeDialog` dispatches. */
export const FEATURE_NOT_IN_PLAN_EVENT = 'jm:feature-not-in-plan'

export function useUpgradeDialog() {
  const ctx = useContext(UpgradeDialogContext)

  if (!ctx) {
    // Never mounted (e.g. a unit test without Providers) — degrade to a no-op
    // rather than throwing, matching useOptionalAuth()'s safe-stub pattern.
    return { openUpgradeDialog: (feature: FeatureKey) => { void feature }, openSeatsUpgradeDialog: () => {}, openPlansDialog: () => {} }
  }

  
return ctx
}
